import React from 'react'
import Image from '../Image/Image'

const ProductImage = props => {
  return <Image {...props} crop={{ width: 2, height: 3 }} placeholder={{ width: 2, height: 3 }} quality={60} />
}

export default ProductImage